<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import router from "@/router";
import Swal from "sweetalert2";
import PrintArea from "@/components/print-area";
import {
  productMethods,
  productComputed,
  productTypeMethods,
  productTypeComputed,
  productCategoriesMethods,
  productCategoriesComputed,
} from "@/state/helpers";
import { MultiListSelect } from "vue-search-select";

export default {
  components: { Layout, PageHeader, PrintArea, MultiListSelect },
  data() {
    return {
      title: "Create Product",
      form: {
        name: "",
        sku: "",
        description: "",
        image: null,
        type_id: 1,
        categories: [{ id: 1, name: "Default" }],
        print_areas: [],
      },
      lastSelectItem: null,
      selectedProductImage: require("@/assets/images/placeholder.webp"),
    };
  },
  methods: {
    ...productMethods,
    ...productTypeMethods,
    ...productCategoriesMethods,
    onSubmit(e) {
      e.preventDefault();
      this.addProduct(this.form)
        .then(() => {
          Swal.fire("Product Created!", "", "success");
          router.push({ name: "products" });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        });
    },
    onReset() { },
    onSelect(items, lastSelectItem) {
      this.form.categories = items;
      this.lastSelectItem = lastSelectItem;
    },
    setSelectedProductImage(event) {
      let tgt = event.target || window.event.srcElement;
      let files = tgt.files;
      const reader = new FileReader();
      reader.onload = () => {
        this.selectedProductImage = reader.result;
      };
      reader.readAsDataURL(files[0]);
      this.form.image = files[0];
    },
    getImagePath(file) {
      if (file && file.constructor.name === "File") {
        return URL.createObjectURL(file);
      }
      return file;
    },
  },
  computed: {
    ...productComputed,
    ...productTypeComputed,
    ...productCategoriesComputed,
  },
  mounted() {
    this.loadProductTypes();
    this.loadProductCategories();
  },
};
</script>
    
<template>
  <Layout>
    <PageHeader :title="title" />

    <b-form @submit="onSubmit" @reset="onReset" enctype="multipart/form-data">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-9">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <b-form-group
                        class="mb-3"
                        id="product-name-group"
                        label="Name:"
                        label-for="product-name"
                      >
                        <b-form-input
                          id="product-name"
                          type="text"
                          v-model="form.name"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-6">
                      <b-form-group
                        class="mb-3"
                        id="product-sku-group"
                        label="SKU:"
                        label-for="product-sku"
                      >
                        <b-form-input
                          id="product-sku"
                          type="text"
                          v-model="form.sku"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>

                  <b-form-textarea
                    id="product-desc"
                    v-model="form.description"
                    placeholder="Product description..."
                    rows="12"
                  ></b-form-textarea>
                </div>
              </div>

              <PrintArea :printAreas="form.print_areas" />

            </div>

            <div class="col-3">
              <div class="card">
                <div class="card-body">
                  <div class="d-grid gap-2">
                    <b-button
                      type="submit"
                      size="lg"
                      :disabled="!(
                        form.type_id &&
                        form.categories.length &&
                        form.print_areas.length
                      )
                        "
                    >
                      <span>Create</span>
                    </b-button>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="mb-3">
                    <label for="product-image">
                      <span class="d-inline-block mb-1">Product Image</span>
                      <b-img
                        thumbnail
                        fluid
                        :src="selectedProductImage"
                      ></b-img>
                      <input
                        class="d-none"
                        type="file"
                        id="product-image"
                        accept="image/png, image/jpeg"
                        name="product-image"
                        @change="setSelectedProductImage"
                      />
                    </label>
                  </div>
                  <b-form-group
                    class="mb-3"
                    id="product-type-group"
                    label="Type:"
                    label-for="product-type"
                  >
                    <b-form-select
                      class="form-control"
                      id="product-type"
                      v-model="form.type_id"
                      :options="productTypes"
                      text-field="name"
                      value-field="id"
                      required
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group
                    id="product-category-group"
                    label="Category:"
                    label-for="product-category"
                  >
                    <multi-list-select
                      :list="productCategories"
                      option-value="id"
                      option-text="name"
                      id="product-category"
                      :selected-items="form.categories"
                      placeholder="select product category"
                      @select="onSelect"
                    >
                    </multi-list-select>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </Layout>
</template>